setTimeout(function() {
  var heading = document.querySelector('.timesact_bis_heading');
  if (heading && heading.textContent.trim() === '') {
    heading.remove();
  }
}, 1000); // Add delay

// ========================================
// ICON BLOCKS POPUP FUNCTIONALITY
// ========================================

document.addEventListener('DOMContentLoaded', function() {
  // Initialize icon blocks popup functionality
  initIconBlocksPopups();
});

function initIconBlocksPopups() {
  // Find all popup trigger buttons
  const popupTriggers = document.querySelectorAll('[data-popup-trigger]');
  
  popupTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      const popupId = this.getAttribute('data-popup-trigger');
      const popup = document.getElementById('popup-' + popupId);
      
      if (popup) {
        openPopup(popup);
      }
    });
  });
  
  // Find all popup close buttons
  const popupCloseButtons = document.querySelectorAll('[data-popup-close]');
  
  popupCloseButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const popupId = this.getAttribute('data-popup-close');
      const popup = document.getElementById('popup-' + popupId);
      
      if (popup) {
        closePopup(popup);
      }
    });
  });
  
  // Close popup when clicking overlay
  const popupOverlays = document.querySelectorAll('.bk-media-popup-overlay');
  
  popupOverlays.forEach(overlay => {
    overlay.addEventListener('click', function(e) {
      if (e.target === this) {
        closePopup(this);
      }
    });
  });
  
  // Close popup with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const activePopup = document.querySelector('.bk-media-popup-overlay.active');
      if (activePopup) {
        closePopup(activePopup);
      }
    }
  });
}

function openPopup(popup) {
  // Close any currently open popups
  const activePopups = document.querySelectorAll('.bk-media-popup-overlay.active');
  activePopups.forEach(activePopup => {
    closePopup(activePopup);
  });
  
  // Open the new popup
  popup.classList.add('active');
  popup.setAttribute('aria-hidden', 'false');
  
  // Prevent body scroll
  document.body.style.overflow = 'hidden';
  
  // Focus the close button for accessibility
  const closeButton = popup.querySelector('.bk-media-popup-close');
  if (closeButton) {
    closeButton.focus();
  }
}

function closePopup(popup) {
  popup.classList.remove('active');
  popup.setAttribute('aria-hidden', 'true');
  
  // Restore body scroll
  document.body.style.overflow = '';
}

// Reinitialize on section load (for dynamic content)
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.bk-media-icon-blocks-container')) {
    initIconBlocksPopups();
  }
});
